import axios from 'axios';

export async function uploadImageToS3(url: string, file: File) {
  const response = await axios.put(url, file, {
    headers: {
      'Content-Type': file.type,
    },
  });

  if (response.status !== 200) {
    throw new Error('Failed to upload image');
  }

  return response;
}
